import {Box, Typography} from "@mui/material";
import {c, softShadow, purpleGradient} from "../landingTokens";
import {Section, Eyebrow} from "./Shell";

const SPECS = [
  ["Languages", "EN, MK, SR, HR — more trainable"],
  ["Response latency", "Under 1 second"],
  ["Concurrent calls", "Elastic, no hard cap"],
  ["Telephony", "SIP trunk → Asterisk"],
  ["Hosting", "EU cloud or on-prem"],
  ["Business systems", "MCP tools + REST"],
  ["Audio transport", "AudioSocket, bidirectional"],
  ["Supervision", "Live monitor, takeover, comments"],
  ["Time to production", "3–6 weeks"],
];

export const Specs = () => (
  <Section id="specs" label="Specs">
    <Eyebrow>Specs</Eyebrow>
    <Typography component="h2" sx={{fontSize: "clamp(30px, 4.2vw, 50px)", lineHeight: 1.05, letterSpacing: "-0.03em", fontWeight: 600, maxWidth: 640, mb: 1.5}}>
      The details, in one place.
    </Typography>
    <Typography sx={{fontSize: 17, lineHeight: 1.5, color: c.inkSoft, maxWidth: 560, mb: 5.5}}>
      Everything you'd ask in a technical review — nothing hidden.
    </Typography>

    <Box sx={{position: "relative", bgcolor: c.white, borderRadius: "28px", boxShadow: softShadow, p: {xs: 3, md: 5}, overflow: "hidden"}}>
      {/* Shared gradient accent, top-left. */}
      <Box aria-hidden sx={{position: "absolute", top: 0, left: 40, width: 44, height: "4px", borderRadius: "0 0 4px 4px", background: purpleGradient}} />

      <Box className="reveal-stagger" sx={{display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", columnGap: 6}}>
        {SPECS.map(([key, value]) => (
          <Box key={key} sx={{borderTop: `1px solid rgba(124,108,246,0.16)`, py: 2.25, display: "flex", justifyContent: "space-between", gap: 2.5, alignItems: "baseline"}}>
            <Typography sx={{fontSize: 14, color: c.inkSoft}}>{key}</Typography>
            <Typography sx={{fontSize: 14.5, fontWeight: 600, color: c.ink, textAlign: "right"}}>{value}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  </Section>
);
